import request from './request';
export const logApi = param => request.post(`/oauthLogin/login/loginByName`, param);
export const loginByTokenApi = param => request.post(`/oauthLogin/login/loginByToken`, param);
export const logOutApi = param => request.get(`/oauthLogin/login/logout`, param);
export const registerApi = param => request.post(`/oauthLogin/register/phone`, param);
export const registerPhoneIsExistApi = param => request.get(`/oauthLogin/register/phoneIsExist`, param);
export const registerRandomCodeApi = param => request.get(`/oauthLogin/register/randomCode`, param);
export const sendVerifyCodeApi = param => request.get(`/oauthLogin/register/sendVerifyCode`, param);
export const getClientIdApi = param => request.get(`/oauthLogin/login/getClientId`);
export const getVersionApi = param => request.get(`${window.location.origin}/media/version.json`, param)
export const applyUnlockApi = param => request.post(`/oauthLogin/login/applyUnlock`, param); 
export const thirdLoginApi = param => request.get(`/login/login/thirdLogin`, param);
export const setOrgApi = param => request.post(`/kmb/ws/person/addOrg`, param);
